import React from 'react';

import {
    Select
} from 'antd';

import {
    _getVmList
} from '../../../services'

const { Option } = Select;

class VmSelector extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            selectedVm: '',
            vmList: []
        }
    }

    render() {

        return(
            <Select value={this.state.selectedVm} style={{ width: 120 }} onSelect={this.onSelect}>
                {this.state.vmList.map(_vm => {
                    return <Option value={_vm}>{_vm}</Option>
                })}
            </Select>
        )
    }

    componentDidMount() {
        _getVmList()
        .then(_vmList => {
            this.setState({
                vmList: _vmList.data
            })
        })
    }

    onSelect = (e) => {
        this.setState({
            selectedVm: e
        },this.props.onSelect(e))
    }

}

export default VmSelector


// WEBPACK FOOTER //
// ./src/components/vm/viewer/selector.js